export default "__VITE_ASSET__e6lTxn6s__"